import { put, call } from 'redux-saga/effects';
import { ChatAction, UIAction } from '../actions';
import { ChatService } from '../services';
import { generateReadableError } from 'hooks';

export function* getRooms(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(ChatAction.getChatRoomsSuccess(null));
  try {
    const { data } = yield call(ChatService.getInstance().fetchChatRooms, action.payload);
    yield put(ChatAction.getChatRoomsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getMessages(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(ChatAction.getChatMessagesSuccess(null));
  try {
    const { data } = yield call(ChatService.getInstance().fetchChatMessages, action.payload);
    console.log('Data---')
    yield put(ChatAction.getChatMessagesSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* sendAccessRequest(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  yield put(ChatAction.makeAccessRequestSuccess(null));
  try {
    const { data } = yield call(ChatService.getInstance().sendAccessRequest, action.payload);
    yield put(ChatAction.makeAccessRequestSuccess(data));
    yield put(UIAction.showMainLoading(false));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}





